var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{class:{
    avatar: _vm.extra_avatar_class,
    'user-details-avatar': !_vm.extra_avatar_class
  },attrs:{"size":_vm.$vuetify.breakpoint.mdAndDown ? _vm.mobile_size : _vm.desktop_size,"color":"primary"}},[_c('v-img',{attrs:{"src":_vm.avatar_uri
        ? _vm.avatar_uri
        : 'https://api-hcms-textract.s3.eu-west-2.amazonaws.com/open/avatars/male_placeholder.jpeg'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }